import { useEffect, useRef } from 'react';
import { useAnalytics } from './useAnalytics';

export const usePageTracking = (pageName: string) => {
  const { trackPageView } = useAnalytics();
  const trackedRef = useRef(false);

  useEffect(() => {
    // Executar apenas UMA vez por página
    if (pageName && !trackedRef.current) {
      trackPageView(pageName);
      trackedRef.current = true;
    }
  }, [pageName, trackPageView]);
};
